import { gql } from 'graphql-request'

export const REMOVE_BOOK_CHAPTER = gql`
  mutation BulkRemoveBookChapter($ids: [Int!]!) {
    bulkRemoveBookChapter(ids: $ids) {
      id
    }
  }
`
